import {createSelector} from 'reselect';

// Technicals sheets redux state
const technicalsSheetsReducerSelector = state => state.technicalsSheets;

// Technicals sheets List
const technicalsSheetsSelector = createSelector(
    technicalsSheetsReducerSelector,
    technicalsSheetsReducer => technicalsSheetsReducer.get('payload')
);

// Technicals sheets is fetching
const technicalsSheetsIsFetchingSelector = createSelector(
    technicalsSheetsReducerSelector,
    technicalsSheetsReducer => technicalsSheetsReducer.get('isFetching')
);

// Technicals sheets error
const technicalsSheetsErrorSelector = createSelector(
    technicalsSheetsReducerSelector,
    technicalsSheetsReducer => technicalsSheetsReducer.get('error')
);

export {
    technicalsSheetsSelector,
    technicalsSheetsIsFetchingSelector,
    technicalsSheetsErrorSelector
};